import * as React from 'react';

import type { OperationVariables, QueryResult } from '@apollo/client';
import { noop } from 'lodash';

import type { SourceHelpers } from '../Source/Source';
import type { SubscribedTasksResponse } from '../Source/SubscribedTaskSource/queries';
import type { TaskResponse } from '../TasksWidget/queries';

export type SubscribedTasksContext = {
  subscribedTasks: TaskResponse[];
  subscribedTaskHelpers: SourceHelpers<TaskResponse>;
  queryResult?: QueryResult<SubscribedTasksResponse, OperationVariables>;
};

const SubscribedTasksContextObject = React.createContext<SubscribedTasksContext>({
  subscribedTasks: [],
  subscribedTaskHelpers: {
    writeToStore: noop,
    deleteFromStore: noop,
  },
  queryResult: undefined,
});

const { Provider, Consumer } = SubscribedTasksContextObject;

const useSubscribedTasks = () => React.useContext(SubscribedTasksContextObject);

export { SubscribedTasksContextObject, Provider, Consumer, useSubscribedTasks };
